type Category = {
  id: number;
  subCategoryname: string;
};

type SidebarProps = {
  categories: Category[];
  selected: number;
  onSelect: (categoryId: number) => void;
};

export default function ProductSidebar({
  categories,
  selected,
  onSelect,
}: SidebarProps) {
  const items: Category[] = [
    { id: 0, subCategoryname: "All Products" },
    ...categories,
  ];

  return (
    <>
      {/* ================= MOBILE: horizontal scroll pills ================= */}
      {/* Sticky di bawah navbar (navbar tingginya 60px, lihat Navbar.tsx)
          supaya user bisa ganti kategori kapan saja tanpa scroll balik
          ke atas dulu -- match pattern umum app e-commerce. */}
      <div
        className="
          lg:hidden

          sticky
          top-[60px]
          z-30

          -mx-8
          bg-white/95
          backdrop-blur-md

          border-b
          border-slate-100

          px-8
          py-3
        ">
        <div className="overflow-x-auto no-scrollbar">
          <div className="flex w-max gap-2.5">
            {items.map((item) => (
              <button
                key={item.id}
                onClick={() => onSelect(item.id)}
                className={`
                  shrink-0
                  whitespace-nowrap

                  rounded-full

                  px-4
                  py-2.5

                  text-sm
                  font-medium

                  transition-all
                  duration-200

                  ${
                    selected === item.id
                      ? "bg-[#324A5A] text-white shadow-md"
                      : "bg-[#ECECEC] text-slate-600 hover:bg-white hover:text-[#324A5A]"
                  }
                `}>
                {item.subCategoryname}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* ================= DESKTOP: sidebar vertikal sticky ================= */}
      <div
        className="
          hidden
          lg:block

          bg-[#ECECEC]
          rounded-[24px]
          p-6
          h-fit
          sticky
          top-20
          z-40
        ">
        <div className="space-y-4">
          {items.map((item) => (
            <button
              key={item.id}
              onClick={() => onSelect(item.id)}
              className={`
                w-full
                text-left
                px-4
                py-3
                rounded-lg

                transition-all
                duration-200

                ${
                  selected === item.id
                    ? `
                      bg-[#324A5A]
                      text-white
                      font-semibold
                      shadow-md
                    `
                    : `
                      text-slate-600
                      hover:bg-white
                      hover:text-[#324A5A]
                    `
                }
              `}>
              {item.subCategoryname}
            </button>
          ))}
        </div>
      </div>
    </>
  );
}
